import { Box, Text } from '@vouched.id/vault';
import React, { useMemo } from 'react';
import { itemHasErrorOrWarning } from '../../utils';
import { Dropdown } from '../Dropdown';
import { DropdownItemsSection } from '../DropdownItemsSection';
import { SingleSpanTable } from '../SingleSpanTable';
import { addIconsToDropdownItems, DropdownItemTypes, DropdownStatusIcon } from '../utils';
export const IPDropdown = ({ jobErrors, jobStatus, ipAddressResults }) => {
    const { dropdownHasWarnings, dropdownHasRejections, dropdownItems } = useMemo(() => {
        const dropdownItemsWithoutIcons = [
            {
                text: 'IP Address',
                type: DropdownItemTypes.ConfidenceDropdownItem,
                available: true,
                hasErrorOrWarning: itemHasErrorOrWarning(jobErrors, 'ipAddressError')
            }
        ];
        return addIconsToDropdownItems(dropdownItemsWithoutIcons);
    }, [jobErrors, itemHasErrorOrWarning, addIconsToDropdownItems]);
    return (React.createElement(Dropdown, { statusIcon: React.createElement(DropdownStatusIcon, { dropdownHasRejections: dropdownHasRejections, dropdownHasWarnings: dropdownHasWarnings, parentJobStatus: jobStatus }), title: "IP" },
        React.createElement(Box, null,
            React.createElement(Text, null, "IP Address Check"),
            React.createElement(DropdownItemsSection, { dropdownItems: dropdownItems }),
            React.createElement(SingleSpanTable, { items: [
                    {
                        label: 'Address',
                        value: ipAddressResults.address
                    },
                    {
                        label: 'Type',
                        value: ipAddressResults.userType
                    },
                    {
                        label: 'Anonymous',
                        value: ipAddressResults.isAnonymous ? 'True' : 'False'
                    },
                    {
                        label: 'City',
                        value: ipAddressResults.city
                    },
                    {
                        label: 'State',
                        value: ipAddressResults.state
                    },
                    {
                        label: 'Country',
                        value: ipAddressResults.country
                    },
                    {
                        label: 'ISP',
                        value: ipAddressResults.isp
                    },
                    {
                        label: 'Organization',
                        value: ipAddressResults.organization
                    },
                    {
                        label: 'Confidence',
                        value: ipAddressResults.confidence
                    },
                    {
                        label: 'Warnings',
                        value: ipAddressResults.warnings
                    }
                ], numColumns: 2 }))));
};
